<template>
  <b-card title="مدیریت گروه های چت">
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  variant="primary"
                  class="mb-1 mr-auto ml-1"
                  :to="{ name: 'addMessageGroup'}"
              >
                جدید
              </b-button>

              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Key"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="warning"
                  @click="update(1)"
                  class="mb-1 mr-1"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>
        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
            :no-local-sorting="true"
        >
          <template #cell(Name)="data">
            <span class="text-nowrap">
              <b-avatar
                  class="mr-1"
                  :src="data.item.Avatar"
              />
              {{ data.item.Name }}
            </span>
          </template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <b-link :to="{ name: 'updateMessageGroup', params: { id: data.item.Id }}">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'messageGroups',
  data() {
    return {
      loading: false,
      filterOptions: {
        Key: null,
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Name',
          label: 'عنوان',
        },
        {
          key: 'Bio',
          label: 'بیوگرافی',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.get(this.$api.messenger.messageGroupList, { params: this.filterOptions })
          .then(res => {
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  },
}
</script>
